module.exports = __webpack_public_path__ + "static/media/ss6.ba92020b.jpg";